export default {
  sports: {
    title: 'AI智慧体育竞赛平台',
    aTitle: '广东佛山南海区',
    longitude: '113.143441',
    latitude: '23.028956',
    address: '广东佛山南海区',
    loginLogo: '@/assets/images/login/sports/logo_login.png',
    loginImg: '@/assets/images/login/sports/bg_login.png',
    topLogo: '@/assets/images/login/sports/logo_top.png',
    favicon: '/favicon_sports.ico',
    isRegisterMode:false,//是否需要注册用户
    defaultPassword:'fooltech123',//(不需要注册用户的默认密码)一定要结合isRegisterMode:false配置
  }
}
